

export const dummyMetricDataNumberCard = [
  { value: "385304", subvalue: "12", type: "currency" },
  { value: "50", subvalue: "12", type: "percentage" },
  { value: "385", subvalue: "12", type: "number" },
];
